import { registerAction } from '../../Action'

const SET_CURRENT_WORKSPACE = 'SET_CURRENT_WORKSPACE'

const reducer = (state = {}, action) => ({
  ...state,
  current_workspace_id: action.payload,
})

const setActiveWorkspace = registerAction(SET_CURRENT_WORKSPACE, { reducer })
let workspaceIdLoaded = false

/* promise to determine once the workspace ID has been loaded */
const hasLoadedWorkspace = new Promise((resolve) => {
  const checker = setInterval(() => {
    if (workspaceIdLoaded) {
      resolve(true)
      clearInterval(checker)
    }
  }, 200)
})

/* dispatch action to set the current workspace */
export const setCurrentWorkspace = (workspaceId) => (dispatch) => {
  workspaceIdLoaded = true
  dispatch(setActiveWorkspace(workspaceId))
}

/* determines if the workspace ID has been loaded */
export const workspaceLoaded = async () => {
  if (workspaceIdLoaded) {
    return true
  }
  await hasLoadedWorkspace
  return true
}

export default setCurrentWorkspace
